import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  visible: boolean;
}
// TODO: remove this component in future
const Display = (props: Props) => {
  const { children, visible } = props;

  if (visible) {
    return <>{children}</>;
  } else {
    return null;
  }
};

export default Display;
